import React from "react";
import {
  CalendarDays,
  HeartHandshake,
  Users,
  User,
  Heart,
  Droplets,
  HandHeart,
} from "lucide-react";
import TopBar from "../components/TopBar";
import ListEditor from "../components/ListEditor";
import { useCustomLists } from "../lib/custom-lists";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";

const LISTS = [
  { key: "eventTypes",        label: "Tipos de evento",       icon: CalendarDays,   iconBg: "bg-brand/5 dark:bg-blue-500/10",    iconColor: "text-brand dark:text-blue-400"    },
  { key: "visitTypes",        label: "Tipos de visita",       icon: HeartHandshake, iconBg: "bg-brand/5 dark:bg-blue-500/10", iconColor: "text-brand dark:text-blue-400" },
  { key: "familyStatuses",    label: "Estados del hogar",     icon: Users,          iconBg: "bg-brand/5 dark:bg-blue-500/10", iconColor: "text-brand dark:text-blue-400"  },
  { key: "spiritualStatuses", label: "Estados espirituales",  icon: User,           iconBg: "bg-brand/5 dark:bg-blue-500/10",  iconColor: "text-brand dark:text-blue-400"   },
  { key: "maritalStatuses",   label: "Estados civiles",       icon: Heart,          iconBg: "bg-brand/5 dark:bg-blue-500/10",    iconColor: "text-brand dark:text-blue-400"    },
  { key: "baptismStatuses",   label: "Estados de bautismo",   icon: Droplets,       iconBg: "bg-cyan-50 dark:bg-cyan-900/20",    iconColor: "text-cyan-600"    },
  { key: "prayerCategories",  label: "Categorías de oración", icon: HandHeart,      iconBg: "bg-indigo-50 dark:bg-indigo-900/20",iconColor: "text-indigo-600"  },
];

export function SettingsListsContent() {
  const { getList, updateList, resetList } = useCustomLists();

  return (
    <div className="px-4 py-4">
      <p className="text-[12px] text-slate-500 dark:text-slate-400 ml-1 mb-4">
        Personaliza las opciones disponibles en formularios y registros pastorales.
      </p>
      <Accordion type="multiple" className="space-y-2">
        {LISTS.map(({ key, label, icon: Icon, iconBg, iconColor }) => (
          <div key={key} className="card-soft overflow-hidden">
            <AccordionItem value={key} className="border-none">
              <AccordionTrigger className="px-4 py-3.5 text-left hover:no-underline [&>svg]:shrink-0">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  <div className={`h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0 ${iconBg}`}>
                    <Icon size={15} className={iconColor} />
                  </div>
                  <p className="text-[14px] font-medium text-slate-900 dark:text-slate-100">{label}</p>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-4 pt-1">
                <ListEditor
                  listKey={key}
                  items={getList(key)}
                  onChange={(next) => updateList(key, next)}
                  onReset={() => resetList(key)}
                />
              </AccordionContent>
            </AccordionItem>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default function SettingsLists() {
  return (
    <div className="anim-in min-h-[100dvh] bg-page-bg pb-[calc(96px+env(safe-area-inset-bottom))] font-sans">
      <TopBar title="Listas y categorías" safeFallback="/settings" />
      <SettingsListsContent />
    </div>
  );
}
